import React, { useState, useEffect } from "react";
import SessionManager from "../../routes/SessionManager";
import CommonUtils from "../../util/CommonUtils";
import Notifications from "../Notifications";
import NavbarLogin from "./NavbarLogin";

function Navbar(props) {

    const [isToggleOn, setIsToggleOn] = useState(false);
    var sessionMgr = new SessionManager();
    const isSessionExpired = sessionMgr.isExpired('user');
    const user = sessionMgr.readCookie('user');
    const permission = CommonUtils.hasPermission("SITESUPT-UI-OWNERS-PORTAL");
    let default_view = user && user.defaultView;

    useEffect(() => {
        const nav = document.querySelector('.navbar-nav.mr-auto');
        if (!nav) return;

        const updateMask = () => {
            nav.classList.toggle('nav-scroll-left', nav.scrollLeft > 0);
            nav.classList.toggle('nav-scroll-right', nav.scrollLeft < nav.scrollWidth - nav.clientWidth - 1);
        };

        let scrollInterval = null;

        const stopScroll = () => {
            clearInterval(scrollInterval);
            scrollInterval = null;
        };

        const handleMouseMove = (e) => {
            const rect = nav.getBoundingClientRect();
            const x = e.clientX - rect.left;
            stopScroll();
            if (x < 50 && nav.classList.contains('nav-scroll-left')) {
                scrollInterval = setInterval(() => { nav.scrollLeft -= 5; updateMask(); }, 16);
            } else if (x > rect.width - 50 && nav.classList.contains('nav-scroll-right')) {
                scrollInterval = setInterval(() => { nav.scrollLeft += 5; updateMask(); }, 16);
            }
        };

        nav.addEventListener('scroll', updateMask);
        nav.addEventListener('mousemove', handleMouseMove);
        nav.addEventListener('mouseleave', stopScroll);
        setTimeout(updateMask, 0);

        return () => {
            stopScroll();
            nav.removeEventListener('scroll', updateMask);
            nav.removeEventListener('mousemove', handleMouseMove);
            nav.removeEventListener('mouseleave', stopScroll);
        };
    }, []);

    const toggleNavbarNav = (e) => {
        e.preventDefault();

        let prevState = !isToggleOn;
        setIsToggleOn(prevState);
        return true;
    }

    const classCollapse = 'navbar-collapse collapse' + (isToggleOn ? ' show' : '');
    const classNavbar = (props.className ? props.className : "") + " nav navbar fixed-top navbar-expand-sm p-1"
    return (
        <div className={classNavbar}>

            <a className="navbar-brand" href={(user.site_locations && user.site_locations.length > 0) && (permission ? "/owners-portal" : (default_view === "Site Map") ? "/sitemap" : default_view === "Map View" ? "/map-view" : "/dashboard")}>
                <img className={props.logo ? "pb-1 svg-logo" : "display-none"} src={props.logo} alt="logo" style={{ width: "90px", marginRight: '15px', marginLeft: '5px' }} />
            </a>

            {isSessionExpired && window.innerWidth < 576 && <Notifications />}

            {props.showNavbarLogin &&
                <React.Fragment>
                    <div className="ml-auto mt-2">
                        {isSessionExpired ? <a href="/dashboard" className="btn btn-white btn-sm">Go To Dashboard</a> : <NavbarLogin />}
                    </div>
                </React.Fragment>
            }
            {
                props.showMenu &&
                <React.Fragment>
                    <button className="navbar-toggler" type="button" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" onClick={(e) => { e.preventDefault(); toggleNavbarNav(e) }}>
                        <div className='menu_bars'>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                            <div>&nbsp;</div>
                        </div>
                    </button>
                    <div className={classCollapse} id="navbarSupportedContent" >
                        {props.children}
                        {props.showNavbarLogin && <NavbarLogin />}
                    </div>
                </React.Fragment>
            }

        </div >
    );
}

export default Navbar;